import React, { useEffect, useState } from 'react';
import {Drawer, Table} from 'antd';

import AddSetupDetails from 'modules/system_setup/add_system_setup_values/addSetupDetails';

const columns = [
    {
        title: "ROLE NAME",
        dataIndex: "role_name",
        key: "role_name",
        width: "25%"
    },
    {
        title: "DESCTIPTION",
        dataIndex: "role_desc",
        key: "role_desc",
        width: "45%"
    },
    {
        title: "DATE CREATED",
        dataIndex: "formatted_date",
        key: "formatted_date",
        width: "15%"
    },
    {
        title: "STATUS",
        dataIndex: "status",
        key: "status",
        width: "15%"
    },
];

function SearchRolesTable(props) {
    const { data, pageSize } = props;
    const [tableData, setTableData] = useState([]);
    const [tableValues, setTableValues] = useState(data);

    const [open, setOpen] = useState(false);
    const showDrawer = () => { setOpen(true); };

    const onClose = () => { 
        setOpen(false); 
        // setTableData([]);
    };

    useEffect(()=> {
        setTableValues(data);
    }, [data]);

    function setData(values) {
        setTableValues(values);
    }

    function refreshTblData(values) {
        console.log('check role refresh', values)
    }

    function updateDrawer(e) {
        setTableData(e)
        showDrawer();
    }

    function drawerClose(value) {
        setOpen(value);
    }

    return(
        <div>
            <Table
                style={ {textTransform: "uppercase"} }
                dataSource = {tableValues}
                columns={columns}
                bordered
                pagination={{ defaultPageSize: 5 }}
                onRow={(record) => {
                    return {
                        onDoubleClick: (e) => {updateDrawer(record)}
                    };
                }}
            />
            <Drawer title={"UPDATE " + props.setupValue} placement="right" onClose={onClose}
                width="30%"
                visible={open}
                destroyOnClose
            >
                <AddSetupDetails 
                    setupDet={props.setupValue} 
                    drawerClose={ drawerClose }
                    refreshTblData={ refreshTblData }
                    tableData={ tableData }
                    setData={ setData }
                    action='UPDATE'
                />
            </Drawer>
        </div>
    )
}

export default SearchRolesTable;